<template>
  <div style="height:100%">
    <el-row :gutter="20">
      <el-col :span="16" style="height:100%;padding:0.5rem 2rem;">
        <b-row align-v="start" style="height:40%">
          <b-col align-self="stretch" style="padding:0">
            <b-img style="height:100%;width: 100%;" :src="articleData.img.url" rounded alt="Rounded image"></b-img>
          </b-col>
        </b-row>
        <b-row align-v="center" class="mt-2" style="height:59%">
          <b-col align-self="stretch" style="padding:0">
            <el-divider content-position="left" style="font-weight:bold;">
              <h5><strong>{{ $t("login.new_infomation") }}</strong></h5>
            </el-divider>
            <div style="height:100%;width: 100%;">
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-card style="height:calc(50vh - 72px);" :body-style="{ padding: '0px' }">
                    <el-link :underline="false" @click="toArticleDetail(articleData.B01)"><img
                        :src="articleData.B01.img.url" class="image" style="height: 230px;"></el-link>
                    <div style="padding: 14px;">
                      <el-link :underline="false" @click="toArticleDetail(articleData.B01)">
                        <h4>{{ articleData.B01.title }}</h4>
                      </el-link>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="8">
                  <el-card style="height:calc(50vh - 72px);" :body-style="{ padding: '0px' }">
                    <el-link :underline="false" @click="toArticleDetail(articleData.B02)"><img
                        :src="articleData.B02.img.url" class="image" style="height: 230px;"></el-link>
                    <div style="padding: 14px;">
                      <el-link :underline="false" @click="toArticleDetail(articleData.B02)">
                        <h4>{{ articleData.B02.title }}</h4>
                      </el-link>
                    </div>
                  </el-card></el-col>
                <el-col :span="8">
                  <el-card style="height:calc(50vh - 72px);" :body-style="{ padding: '0px' }">
                    <el-link :underline="false" @click="toArticleDetail(articleData.B03)"><img
                        :src="articleData.B03.img.url" class="image" style="height: 230px;"></el-link>
                    <div style="padding: 14px;">
                      <el-link :underline="false" @click="toArticleDetail(articleData.B03)">
                        <h4>{{ articleData.B03.title }}</h4>
                      </el-link>
                    </div>
                  </el-card></el-col>
              </el-row>
            </div>
          </b-col>
        </b-row>

      </el-col>
      <el-col :span="8" style="height:100%;padding:0.5rem 2rem;">
        <b-row align-v="start" style="height:33%">
          <b-col align-self="stretch" style="padding:0">
            <el-divider content-position="left" style="margin:12px 0 !important">
              <h6><strong>{{ $t("login.new_notice") }}</strong></h6>
            </el-divider>
            <el-card class="inner">
              <el-timeline class="pl-4">
                <el-timeline-item v-for="(activity, index) in articleData.R01" :key="index" :icon="activity.icon"
                  :type="activity.type" :color="activity.color" :size="activity.size" :timestamp="activity.timestamp">
                  {{ activity.content }}
                </el-timeline-item>
              </el-timeline>
            </el-card>
          </b-col>
        </b-row>
        <b-row align-v="center" class="mt-2" style="height:33%">
          <b-col align-self="stretch" style="padding:0">
            <el-divider content-position="left">
              <h6><strong>{{ $t("login.company_dynamic") }}</strong></h6>
            </el-divider>
            <el-card class="inner">
              <el-timeline class="pl-4">
                <el-timeline-item class="mb-0" v-for="(activity, index) in articleData.R02" :key="index"
                  :icon="activity.icon" :type="activity.type" :color="activity.color" :size="activity.size"
                  :timestamp="activity.timestamp">
                  {{ activity.content }}
                </el-timeline-item>
              </el-timeline>
            </el-card>
          </b-col>
        </b-row>
        <b-row align-v="end" class="mt-2" style="height:32%">
          <b-col align-self="stretch" style="padding:0">
            <el-divider content-position="left">
              <h6><strong>{{ $t("login.quick_links") }}</strong></h6>
            </el-divider>
            <el-card style="background-color: #f8f8f9;height:calc(30vh - 90px);">
              <div v-for="(item, index) in articleData.quick_links" :key="index"
                style="font-size:14px;font-weight:bold;padding: 0.5rem 1.2rem;">
                <i class="el-icon-caret-right mr-2" style="color:#ffd100;font-size:18px"></i> <a :href="item.url"
                  target="_blank" style="color:#202020 !important">{{ item.label }}</a>
              </div>
            </el-card>
          </b-col>
        </b-row>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as SystemSettingController from "../controllers/system/SystemSettingController"
import { EventBus } from "../shared/event_bus"
export default {
  name: "dashboard",
  data: function () {
    return {
      selected: "Month",
      articleData: {
        img: {
          idx: "",
          category: "",
          code: "",
          fileName: "",
          url: ""
        },
        B01: {
          img: {},
          title: "",
          content: ""
        },
        B02: {
          img: {},
          title: "",
          content: ""
        },
        B03: {
          img: {},
          title: "",
          content: ""
        },
        R01: [],
        R02: [],
        quick_links: []
      },
    }
  },
  async mounted() {
    await this.GetData()
  },
  methods: {
    variant(value) {
      let $variant
      if (value <= 25) {
        $variant = "info"
      } else if (value > 25 && value <= 50) {
        $variant = "success"
      } else if (value > 50 && value <= 75) {
        $variant = "warning"
      } else if (value > 75 && value <= 100) {
        $variant = "danger"
      }
      return $variant
    },
    flag(value) {
      return "flag-icon flag-icon-" + value
    },
    async GetData() {
      let result = await SystemSettingController.methods.GetData({ code: { "=": "dashboard_setting" } })
      if (result[0].length < 1)
        return
      else if (result[0][0].setting_value)
        this.articleData = JSON.parse(result[0][0].setting_value)
    },
    toArticleDetail(data) {
      this.$router.push({ name: "ArticleDetail", params: { data } })
    },
  },

  beforeRouteEnter(to, from, next) {
    EventBus.$emit('enter_dashboard')
    next()
  },

  beforeRouteLeave(to, from, next) {
    EventBus.$emit('leave_dashboard')
    next()
  }
}
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.inner {
  background-color: #f8f8f9;
  overflow-y: auto;
  height: calc(30vh - 83px);
}

.inner::-webkit-scrollbar {
  width: 0 !important;
}
</style>
